const userAgent = window.navigator.userAgent.toLowerCase()
const isIos = /iphone|ipad|ipod/.test( userAgent )

const initialState = {
	loadedScripts: [],
	isIos: isIos,
	screenWidth: window.innerWidth,
	screenHeight: window.innerHeight,
	isMobile: window.innerWidth <= siteData.mobile_max_width,
	menuIsOpen: false,
	hasDismissedNewsletterModal: localStorage.getItem( 'hasDismissedNewsletterModal' ) || false,
}

export default function reducer( state = initialState, action ) {
	const { payload } = action

	switch ( action.type ) {
		case 'ADD_SCRIPT':
			return {
				...state,
				loadedScripts: [
					...state.loadedScripts,
					payload
				]
			}

		case 'GET_SCREEN_SIZE':
			return {
				...state,
				screenWidth: window.innerWidth,
				screenHeight: window.innerHeight,
				isMobile: window.innerWidth <= siteData.mobile_max_width
			}

		case 'OPEN_MENU':
			return {
				...state,
				menuIsOpen: true
			}

		case 'CLOSE_MENU':
			return {
				...state,
				menuIsOpen: false
			}

		case 'SET_MENU_OPEN_STATE':
			return {
				...state,
				menuIsOpen: payload
			}

		case 'HAS_DISMISSED_NEWSLETTER_MODAL':
			return {
				...state,
				hasDismissedNewsletterModal: true
			}
	}

	return state
}



// WEBPACK FOOTER //
// ./redux/reducers/site.jsx